import * as HLF from "html-living-framework";
import { BalloonControlToken } from "../Data/BalloonControlToken";
import * as Constants from "../Data/Constants";
import * as Topics from "../Data/Topics";
import { Button } from "../GameObjects/Button";
import { BalloonParameter } from "../GameObjects/DebugBalloonControls";

export class DebugParameterControls extends PIXI.Container {
    private static readonly ASSETS: string[] = [ "--", "-", "+", "++" ];

    private _buttons: Button[];
    private _text: PIXI.extras.BitmapText;
    private _label: PIXI.extras.BitmapText;

    private _min: number;
    private _max: number;
    private _deltaSmall: number;
    private _deltaLarge: number;
    private _value: number;
    private _param: BalloonParameter;

    constructor(pLabel: string, pParam: BalloonParameter, pMin: number, pMax: number, pDeltaSmall: number,
                pDeltaLarge: number) {
        super();
        this._value = 0;
        this._param = pParam;
        this._min = pMin;
        this._max = pMax;
        this._deltaSmall = pDeltaSmall;
        this._deltaLarge = pDeltaLarge;

        this._buttons = new Array<Button>(4);
        const mods: number[] = [ -this._deltaLarge, -this._deltaSmall, this._deltaSmall, this._deltaLarge ];
        const offset: number[] = [ -2.5, -1.5, 1.5, 2.5 ];
        for (let i = 0; i < this._buttons.length; ++i) {
            const index: number = i;
            this._buttons[i] = new Button(
                () => { this.changeValue(mods[index]); },
                DebugParameterControls.ASSETS[i], Constants.SPRITESHEET_UI,
            );
            this._buttons[i].position.set(offset[index] * 60, 20);
            this._buttons[i].scale.set(0.4);
            this.addChild(this._buttons[i]);
        }

        this._text = new PIXI.extras.BitmapText(this._value.toString(), {
            font: Constants.FONT_GEL_PEN_MED_35,
            align: "left", // TODO:SH: FontUtils that contains these alignments as consts
            tint: (new HLF.Colour(0, 0, 0)).toHex(),
        });
        this._text.position.x = -50;
        this.addChild(this._text);

        this._label = new PIXI.extras.BitmapText(pLabel.toString(), {
            font: Constants.FONT_GEL_PEN_MED_35,
            align: "left", // TODO:SH: FontUtils that contains these alignments as consts
            tint: (new HLF.Colour(0, 0, 0)).toHex(),
        });
        this._label.position.x = -350;
        this.addChild(this._label);
    }

    private changeValue(pDelta: number): void {
        this.value = this._value + pDelta;
    }

    public set value(pValue: number) {
        this._value = HLF.MathUtils.clamp(pValue, this._min, this._max);
        this._text.text = this._value.toString();
        PubSub.publishSync(
            Topics.ON_DEBUG_BALLOON_PARAM_CHANGED,
            new BalloonControlToken(this._param, this._value),
        );
    }
}
